// extracted by mini-css-extract-plugin
export default {"videoContainer":"videoDetails_videoContainer__abFFN","videoBox":"videoDetails_videoBox__OEf8n"};